var map = {
	"./brands.de-CH.json": 1619,
	"./brands.de-DE.json": 1620,
	"./brands.en-CA.json": 1621,
	"./brands.en-GB.json": 1622,
	"./brands.en-IN.json": 1623,
	"./brands.en-ME.json": 1624,
	"./brands.en-US.json": 1625,
	"./brands.es-EM.json": 1626,
	"./brands.es-ES.json": 1627,
	"./brands.fr-BE.json": 1628,
	"./brands.fr-CA.json": 1629,
	"./brands.fr-CH.json": 1630,
	"./brands.nl-BE.json": 1631,
	"./brands.nl-NL.json": 1632,
	"./brands.pl-PL.json": 1633,
	"./brands.pt-BR.json": 1634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1618;